export const promote = (config) => ({ ...config });
//# sourceMappingURL=chat-handoff-1-to-2.js.map